import axios from '../utils/axios';

export default function fetchSubscriptions(adminId, params) {
        return (
            axios.get('/admin/' + adminId + '/manageSeekerSubscriptions/subscription/admin/transactions', { params })
            .then(response => {
                return response.data;
            })
        )   
}
